
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { mkConfig, generateCsv, download } from "export-to-csv";
import { Button } from "react-bootstrap";



export const ExportToCSV = ({ columns, data = [], filename, statuses }) => {



    const handleExport = () => {

        const headers = columns.reduce((acc, col) => {
            if (col.Header === "Created By/On") {
                acc.push("Created By", "Created On");
            } else if (col.Header === "Modified By/On") {
                acc.push("Modified By", "Modified On");
            } else {
                acc.push(col.Header);
            }
            return acc;
        }, []);

        const csvdata = data.map(row => {
            const mappedRow = columns.reduce((acc, col) => {
                if (col.Header === "Created By/On") {
                    acc["Created By"] = row.createdBy;
                    acc["Created On"] = row.createdOn;
                } else if (col.Header === "Modified By/On") {
                    acc["Modified By"] = row.modifiedBy;
                    acc["Modified On"] = row.modifedOn;
                } 
                else if (col.Header === "Status") {
                    acc[col.Header] = row[col.accessor] ? statuses[0] : statuses[1];
                } 
                else if (col.Header === "Featured") {
                    acc[col.Header] = row[col.accessor] ? 'Featured' : '';
                } 
                else if (col.Header === 'Event Location') {
                    const Desc = JSON.parse(row.description)
                    acc[col.Header] = Desc.eventLocation;
                }
                else if (col.Header === 'Designation') {
                    const Desc = JSON.parse(row.description)
                    acc[col.Header] = Desc.description;
                }
                else if (col.Header === 'Serving Details') {
                    const Desc = JSON.parse(row.description)
                    acc[col.Header] = Desc.description;
                }
                 else {
                    acc[col.Header] = row[col.accessor];
                }
                return acc;
            }, {});
            return mappedRow;
        });




        const csvConfig = mkConfig({ useKeysAsHeaders: false, columnHeaders: headers, filename: `DREAMS-I ${filename}` });
        const csv = generateCsv(csvConfig)(csvdata);
        download(csvConfig)(csv)


    }


    return (
        <>
            <Button
                size="sm"
                variant="outline-secondary"
                disabled={!data.length}
                className="border-300 hover-border-secondary"
                onClick={() => handleExport()}
            >
                <FontAwesomeIcon icon="arrow-down" className="fs-10 me-2" />
                Export CSV
            </Button>
        </>
    )

}